<template>
    <div id="app" class="container-fluid mh-100" style="background: #FFFFFF">
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>

<script>
import DefaultLayout from "@/layout/DefaultLayout";
import EmptyLayout from "@/layout/EmptyLayout";
import {mapActions, mapGetters} from "vuex";
import Sidebar from "./components/Sidebar";
import localToken from "@/store/local/localToken";
import localStorageLang from "@/store/local/localStorageLang";
import loginMixin from "@/mixin/loginMixin";
import Alert from "@/components/html/Alert.vue";

export default {
    name: 'App',
    components: {Alert, Sidebar, EmptyLayout, DefaultLayout},
    mixins: [loginMixin],
    computed: {
        ...mapGetters([
            'isAuthenticated',
            'getUser',
            'getUserCompanyId',
            'getCheckUpProgressStatus'
        ]),
        layout() {
            return this.$route.meta.layout || 'DefaultLayout'
        }
    },
    methods: {
        ...mapActions([
            'fetchUser',
            'clearTokens',
            'fetchRefreshToken',
            'fetchTopProductsLastPeriod',
            'fetchSaleDailyStat',
            'fetchSaleWeeklyStat',
            'fetchSaleMonthlyStat',
            'fetchSaleYearlyStat',
            'fetchCompanyPayTypeStatistics',
            'fetchSaleProductRatingAllPeriod',
            'fetchProductsSearch',
            'fetchProductsIsNotify',
            'fetchRepaymentDateSales',
            'fetchProductsExpired',
            'fetchCheckUpProgressStatus'
        ]),
        getTodayDate() {
            let yearNow = new Date().getFullYear()
            let monthNow = new Date().getMonth() + 1
            let dateNow = new Date().getDate()

            return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
        setCookie(name, value, days) {
            let expires = ''

            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }

            let domain = ''

            if (process.env.NODE_ENV === 'production') {
                domain = 'domain=.boshqar.com'
            }

            document.cookie = name + "=" + (value || "") + expires + `; path=/; ${domain}`;
        },
        getBooleanFromLocalStorage(key) {
            const value = localStorage.getItem(key)
            return value === 'true'
        },
    },
    beforeCreate() {
        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        // get token from cookie
        const access =  getCookie('access')
        const refresh = getCookie('refresh')
        const lang =  getCookie('lang')

        this.$store.dispatch('setToken', {accessToken: access, refreshToken: refresh})
        localStorage.setItem('lang', lang)
    },
    async created() {
        document.title = process.env.VUE_APP_NAME

        if (this.isAuthenticated && this.getUser.id === null) {
            this.$root.showOverlay = true

            await this.fetchUser()
                .then(() => {
                    this.fetchProductsIsNotify()
                        .then(() => {
                            this.fetchRepaymentDateSales()
                                .then(() => {
                                    this.fetchProductsExpired()
                                })
                        })
                })
                .catch(() => {
                    this.fetchRefreshToken()
                        .then(() => {
                            this.fetchUser()
                                .finally(() => {
                                    this.$root.showOverlay = false
                                })
                        })
                        .catch(() => {
                            this.clearTokens()
                            this.$root.showOverlay = false
                        })
                })
        }
    },
    mounted() {
        document.body.style.zoom = '80%'

        this.fetchCheckUpProgressStatus()
            .then(() => {
                if (this.getCheckUpProgressStatus && this.getBooleanFromLocalStorage('isIosApp')) {
                    localStorage.setItem('checkUpProgressStatus', 'true')
                } else {
                    localStorage.setItem('checkUpProgressStatus', 'false')
                }
            })
    },
    watch: {
        '$route.path': function () {
            this.$root.showSidebar = false
        },
        getUserCompanyId: {
            deep: true,
            handler: function (newVal) {
                this.setCookie('access', localToken.getAccess(), 7)
                this.setCookie('refresh', localToken.getRefresh(), 7)
                this.setCookie('lang', localStorageLang.get(), 7)

                this.$store.state.product.purchasePageProducts.isNeedFetch = true

                this.fetchProductsSearch(newVal)
                    .then(() => {
                        this.fetchTopProductsLastPeriod()
                            .then(() => {
                                this.fetchSaleDailyStat()
                                    .then(() => {
                                        this.fetchSaleWeeklyStat()
                                            .then(() => {
                                                this.fetchSaleMonthlyStat()
                                                    .then(() => {
                                                        this.fetchSaleYearlyStat()
                                                            .then(() => {
                                                                this.fetchSaleProductRatingAllPeriod()
                                                                    .then(() => {
                                                                        this.fetchCompanyPayTypeStatistics({
                                                                            dateFrom: this.getTodayDate() + ' 00:00:00',
                                                                            dateTo: this.getTodayDate() + ' 23:59:59'
                                                                        })
                                                                    })
                                                            })
                                                    })
                                            })
                                    })
                            })
                    })
            }
        },
    }
}
</script>
<style>
/* fade */
.fade-leave-to, .fade-enter-to {
    opacity: 0.5;
}

.fade-enter, .fade-leave {
    opacity: 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

</style>
